// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/portfolio-permissions/app/css/app.css
// module id = 823
// module chunks = 0